angular.module('bmsApp.merrymaids', [
	'bmsApp.merrymaids.job',
	'bmsApp.merrymaids.schedule',
	'bmsApp.merrymaids.cis',
	'bmsApp.merrymaids.houseTemplate',
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.merrymaids', {
					abstract: true,
					url: '/merrymaids'
				})

				.state('breakout.merrymaids', {
					abstract: true
				})

			;
		}]);
